import { decodeHexResponse } from '../_common/common.utils';
import RefreshmentApprovalTypes from './RefreshmentApproval.types';

const INITIAL_STATE = {
    refreshmentApprovalResponse: null,
    calculateRefreshmentResponse: null,
    approveRefreshmentResponse: null,
    bulkApproveRefreshmentResponse: null,
    rejectRefreshmentResponse: null,
    error: null,
};

interface RefreshmentApprovalState {
    refreshmentApprovalResponse: any;   
    calculateRefreshmentResponse: any;
    approveRefreshmentResponse: any;
    bulkApproveRefreshmentResponse: any;
    rejectRefreshmentResponse: any;
    error: any;
}

interface RefreshmentApprovalAction {
    type: string;
    payload: any;
}

const refreshmentApprovalReducer = (state = INITIAL_STATE, action: RefreshmentApprovalAction): RefreshmentApprovalState => {
    switch (action.type) {
        case RefreshmentApprovalTypes.REFRESHMENT_APPROVAL_START:
            return { ...state, refreshmentApprovalResponse: null };
        case RefreshmentApprovalTypes.REFRESHMENT_APPROVAL_SUCCESS:         
            return { ...state, 
                refreshmentApprovalResponse:decodeHexResponse(action.payload,"fetchRefreshmentApprovalkey")};
        case RefreshmentApprovalTypes.REFRESHMENT_APPROVAL_FAILURE:
            return { ...state, 
                refreshmentApprovalResponse:decodeHexResponse(action.payload,"fetchRefreshmentApprovalkey") };
        
        case RefreshmentApprovalTypes.CALCULATE_REFRESHMENT_START:
            return { ...state, calculateRefreshmentResponse: null };
        case RefreshmentApprovalTypes.CALCULATE_REFRESHMENT_SUCCESS:
            return { ...state, 
                calculateRefreshmentResponse:decodeHexResponse(action.payload,"calculateRefreshmentKey") };
        case RefreshmentApprovalTypes.CALCULATE_REFRESHMENT_FAILURE:
            return { ...state,  
                calculateRefreshmentResponse:decodeHexResponse(action.payload,"calculateRefreshmentKey") };
        
        case RefreshmentApprovalTypes.APPROVE_REFRESHMENT_START:
            return { ...state, approveRefreshmentResponse: null };
        case RefreshmentApprovalTypes.APPROVE_REFRESHMENT_SUCCESS:
            return { ...state, 
                approveRefreshmentResponse:decodeHexResponse(action.payload,"approveRefreshmentKey") };
        case RefreshmentApprovalTypes.APPROVE_REFRESHMENT_FAILURE:
            return { ...state, 
                approveRefreshmentResponse:decodeHexResponse(action.payload,"approveRefreshmentKey") };
        
        case RefreshmentApprovalTypes.BULK_APPROVE_REFRESHMENT_START:
            return { ...state, bulkApproveRefreshmentResponse: null };
        case RefreshmentApprovalTypes.BULK_APPROVE_REFRESHMENT_SUCCESS:
            return { ...state, 
                bulkApproveRefreshmentResponse: decodeHexResponse(action.payload,"bulkApproveRefreshmentKey") };
        case RefreshmentApprovalTypes.BULK_APPROVE_REFRESHMENT_FAILURE:
            return { ...state, 
                bulkApproveRefreshmentResponse: decodeHexResponse(action.payload,"bulkApproveRefreshmentKey") };
        
        case RefreshmentApprovalTypes.REJECT_REFRESHMENT_START:
            return { ...state, rejectRefreshmentResponse: null };
        case RefreshmentApprovalTypes.REJECT_REFRESHMENT_SUCCESS:
            return { ...state, 
                rejectRefreshmentResponse: decodeHexResponse(action.payload,"rejectRefreshmentKey") };
        case RefreshmentApprovalTypes.REJECT_REFRESHMENT_FAILURE:
            return { ...state, 
                rejectRefreshmentResponse: decodeHexResponse(action.payload,"rejectRefreshmentKey") };
        
        default:
            return state;
    }
};

export default refreshmentApprovalReducer; 